import { ElectricalContainer } from './electrical-container';
import { Wire } from '../wires/wire';
import { Line } from '../wires/line';

export class SinglePole extends ElectricalContainer {
  protected getWireForParent(): Wire[] {
    return [new Line()];
  }
}
